import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Use a stronger password (min 6 characters)"); return; }
    setBusy(true);
    try {
      await register(name, email, password);
      toast.success("Welcome to South on Leadership.");
      navigate("/library");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create account");
    } finally { setBusy(false); }
  };

  return (
    <Layout hideFooter>
      <SEO title="Create account" description="Create your South on Leadership account." noindex />
      <section className="container-narrow py-16 md:py-24 max-w-lg">
        <span className="overline text-brand-rust">Create account</span>
        <h1 className="font-display text-5xl mt-3 text-brand-ink">Join the library.</h1>
        <div className="mt-10 bg-white border border-brand-line p-8 md:p-10">
          <form onSubmit={submit} className="space-y-4" data-testid="register-form">
            <div>
              <Label htmlFor="name" className="overline text-brand-inkMuted">Name</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="rounded-none mt-2 border-brand-line focus:border-brand-ink focus:ring-0" />
            </div>
            <div>
              <Label htmlFor="email" className="overline text-brand-inkMuted">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="rounded-none mt-2 border-brand-line focus:border-brand-ink focus:ring-0" />
            </div>
            <div>
              <Label htmlFor="password" className="overline text-brand-inkMuted">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="rounded-none mt-2 border-brand-line focus:border-brand-ink focus:ring-0" />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid="register-submit"
              className="w-full bg-brand-ink text-white hover:bg-black py-3 text-sm font-medium tracking-wide transition-colors disabled:opacity-60"
            >{busy ? "Creating account…" : "Create account"}</button>
            <p className="text-sm text-brand-inkMuted text-center">
              Already have an account? <Link to="/login" className="text-brand-rust hover:underline">Sign in</Link>
            </p>
          </form>
        </div>
      </section>
    </Layout>
  );
}
